import {CSVLink} from 'react-csv';
import {PropsWithChildren, useMemo} from 'react';
import {TransportMethod, StatisticsGroupWrapper, StatisticsType, TransportCategory} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {LinkProps} from "react-csv/components/Link";

type StatisticsExportLinkProps = Pick<LinkProps, "onClick"> & {
  filePrefix?: string;
  data?: StatisticsGroupWrapper[]
  rateModel?: string
  category?: TransportCategory
  method?: TransportMethod
  types: StatisticsType[]
}

export function StatisticsExportLink(props: PropsWithChildren<StatisticsExportLinkProps>) {
  const {
    filePrefix,
    data,
    rateModel,
    category,
    method,
    types,
    children,
    ...rest
  } = props;

  const {t} = useTranslation(["common"])

  const csvHeaders: string[] = useMemo(() => {
    const headers = ["Name"]
    for (const type of types) {
      headers.push(t(type.displayValue.id, type.displayValue.defaultMessage))
    }
    return headers
  }, [types, t]);

  const exportData: string[][] = useMemo(() => {
    const csvLines: string[][] = []

    if (data) {
      for (const group of data) {
        const line: string[] = [group.name]

        for (const type of types) {
          const value: number | undefined = group.getValue(method, type, rateModel, category)
          line.push(value?.toString() ?? "")
        }

        csvLines.push(line)
      }
    }

    return csvLines
  }, [data, rateModel, category, method, types]);

  const exportFileName = useMemo(() => {
    let prefix = '';
    if (filePrefix) {
      prefix = filePrefix + '_';
    }
    return prefix + new Date().getTime() + '_export.csv';
  }, [filePrefix]);

  if (exportData && exportData.length > 0) {
    return (
      <CSVLink {...rest} style={{textDecoration: "none"}} headers={csvHeaders} data={exportData} filename={exportFileName}>
        {children ? children : t("common.action.export", "Export")}
      </CSVLink>
    );
  }

  return null;
}
